module.exports = require("./nn.d.ts");